import { Route, Redirect, useHistory } from "react-router";
import React from "react";

import TabOnePage from "../pages/TabOnePage";
import TabTwoPage from "../pages/TabTwoPage";
import TabEditPage from "../pages/TabEditPage";

import {
  IonTabs,
  IonTabBar,
  IonTabButton,
  IonLabel,
  IonRouterOutlet,
  IonIcon
} from "@ionic/react";
import { home, time, pencil, person } from 'ionicons/icons';
import * as firebase from "firebase";

// MOBX
import { MobXProviderContext, observer } from "mobx-react";
import TabOneDetailPage from "./TabOneDetailPage";

const HomePage = () => {
  const { store } = React.useContext(MobXProviderContext);
  const [password, setPassword] = React.useState(null);
  const [firstName, setFirstName] = React.useState(null);
  const [lastName, setLastName] = React.useState(null);
  const [email, setEmail] = React.useState(false);
  const [accountId, setAccountId] = React.useState(window.localStorage.getItem('account_id'));
  const history = useHistory();

  const addHistory = () =>{
    var mid1 = window.localStorage.getItem('mid1');
    if(mid1){
      let ruser_id = window.localStorage.getItem('ruserid');
      let ruser_name = window.localStorage.getItem('rusername');
      let messages1=[];
      firebase.firestore().collection('messages').doc(mid1).collection('list').get().then(results => {
        results.docs.forEach(d=>{
          messages1.push(d.data());
        });
        firebase.firestore().collection('history').doc(window.localStorage.getItem('account_id')).collection('data').add({ruser_id:ruser_id,ruser_name:ruser_name,messages:messages1,date:new Date()});
      });
      window.localStorage.removeItem('mid1');
    }
  }
  React.useEffect(() => {
    window.otpless = async(otplessUser) => {
      if(otplessUser?.token){
        console.log(1);
        firebase.firestore().collection('accounts').where('phone', '==', '+'+otplessUser?.mobile?.number).limit(1).get().then(results => {
          if(results.docs.length>0){
            console.log(2);console.log(results.docs[0].data());
            window.localStorage.setItem('account_id',results.docs[0].id);
            window.localStorage.setItem('account_data',JSON.stringify(results.docs[0].data()));
            setAccountId(results.docs[0].id);
            setFirstName(results.docs[0].data().name);
            setLastName(results.docs[0].data().phone);
            setEmail(results.docs[0].data().email);
            setPassword(null);
          }
          else{
            firebase.firestore().collection('accounts').where('email', '==', otplessUser?.email?.email).limit(1).get().then(results => {
              if(results.docs.length>0){
                console.log(3);console.log(results.docs[0].data());
                window.localStorage.setItem('account_id',results.docs[0].id);
                window.localStorage.setItem('account_data',JSON.stringify(results.docs[0].data()));
                setAccountId(results.docs[0].id);
                setFirstName(results.docs[0].data().name);
                setLastName(results.docs[0].data().phone);
                setEmail(results.docs[0].data().email);
                setPassword(null);
              }
              else{
                console.log(4);
                firebase.firestore().collection('accounts').add({email:otplessUser?.email?.email,name:otplessUser?.mobile?.name,phone:'+'+otplessUser?.mobile?.number,userid:window.localStorage.getItem('userid')}).then((value)=>{
                  window.localStorage.setItem('account_id',value.id);
                  window.localStorage.setItem('account_data',JSON.stringify({email:otplessUser?.email?.email,name:otplessUser?.mobile?.name,phone:'+'+otplessUser?.mobile?.phone}));
                  console.log(value);
                  setAccountId(value.id);
                  setFirstName(otplessUser?.mobile?.name);
                  setLastName('+'+otplessUser?.mobile?.phone);
                  setEmail(otplessUser?.email?.emai);
                  setPassword(null);
                });
              }
            });
          }
        });
        //data
        addHistory();
      }
    };
    if (window.location.href=='http://localhost:8100/' || window.location.href=='https://form.onehotcode.com/') {
      history.replace("/tabs/home");
    }
  }, []);
  return (
    <IonTabs>
      <IonRouterOutlet>
        <Route path="/tabs/home" exact={true}>
          <TabOnePage />
        </Route>
        <Route path="/tabs/home/link" exact={true}>
          <TabOnePage />
        </Route>
        <Route path="/tabs/connect/:userId" exact={true}>
          <TabOnePage />
        </Route>
        <Route path="/tabs/time" exact={true}>
          <TabOneDetailPage />
        </Route>
        <Route path="/tabs/edit" exact={true}>
          <TabEditPage />
        </Route>
        <Route path="/tabs/settings" exact={true}>
          <TabTwoPage />
        </Route>
        {/*<Route path="/tabs" render={() => <Redirect to="/tabs/home" />} />*/}
      </IonRouterOutlet>

      <IonTabBar slot="bottom">
        <IonTabButton tab="tab1" href="/tabs/home">
          <IonIcon icon={home} />
        </IonTabButton>
        <IonTabButton tab="tab2" href="/tabs/time">
          <IonIcon icon={time} />
        </IonTabButton>
        <IonTabButton tab="tab3" href="/tabs/edit">
          <IonIcon icon={pencil} />
        </IonTabButton>
        <IonTabButton tab="tab4" href="/tabs/settings">
          <IonIcon icon={person} />
        </IonTabButton>
      </IonTabBar>
    </IonTabs>
  );
};

export default observer(HomePage);
